import { isString } from 'lodash';
import { logger } from 'services';
import { isValidEmail } from './is-valid-email';
export const initials = (name = '')=>{
    if (!isString(name)) {
        logger.warn('Invalid data is being passed', name);
        return '';
    }
    const initials_string = isValidEmail(name) ? name.substr(0, 2) : (name.match(/\b\w/g) || []).join('').substr(0, 2);
    return initials_string.toLocaleUpperCase();
};
